import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ButtonConfig } from '@collab/comp-library';
import { LoaderService } from '../../services/loader.service';
import { Clipboard } from '@angular/cdk/clipboard';
import { AlertsService } from '../../services/alerts.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss']
})
export class CardComponent implements OnInit {
  constructor(private loader: LoaderService, private clipBoard: Clipboard,public alertService:AlertsService, private router:Router) { }
  public alertRecordList:any
 public remediationMessage:any[] = [];
 // ngAfterViewInit(): void {
  //   if (this.CardTitle === 'Run Opex Modelling(with outsourcing onsite only)') {
  //     this.btnElement.nativeElement.focus()
  //   }
  // }
  public isReady=false
  public aiGenerated=false
  public genAiGenerated=false
  public showText:boolean=false;
  @Input() CardTitle!: string;
  @Input() arialabel!: string;
  @Input() IconTitle: string = 'Copy Code';
  @Input() CopyIcon:string='/assets/mail.svg'
  @Output() onViewMore: EventEmitter<any> = new EventEmitter<any>();
  @Output() onEdit: EventEmitter<any> = new EventEmitter<any>();
  @Input() icon!: string;
  @Input() iconHeight: string = '30px';
  @Input() iconWidth: string = '30px';
  @Input() id!: string
  @ViewChild('button') btnElement!: ElementRef
  handleViewMore(event: any) {
    this.btnElement.nativeElement.focus()
    this.onViewMore.emit(event);
  }
  handleEdit(event: any) {
    this.onEdit.emit(event);
  }
  onImgLoad() {
    this.loader.hide();
  }
  ngOnInit(): void {
    this.alertRecordList = this.alertService.alertDataList;

    if(this.router.url.indexOf('suggested-solution') > -1){
      this.aiGenerated=true
    }
    if(this.router.url.indexOf('suggested-solution') > -1){
      this.genAiGenerated=true
    }
    if (this.alertRecordList.remediationCommands.length > 0 && this.aiGenerated) {
      this.isReady=false
      this.remediationMessage = this.alertRecordList.remediationCommands;
    } else if (this.alertRecordList.remediationCommandsML.length > 0 && this.genAiGenerated) {
      this.isReady=false
        this.remediationMessage = this.alertRecordList.remediationCommandsML;
    } else {
      this.isReady=true
        this.remediationMessage = ['No Commands Found'];

    }
}
public onCopy(){
  let messageToCopy;
  if(Array.isArray(this.remediationMessage)) {
      messageToCopy = this.remediationMessage.join('\n');
  } else {
      messageToCopy = this.remediationMessage;
  }
  this.clipBoard.copy(messageToCopy);
  this.showText = true;
  setTimeout(() => {
      this.showText = false;
  }, 5 * 1000);

}
public containsNoRecords(): boolean {
  return this.remediationMessage.some(message => message.includes('No Commands Found'));
}
}
